import React, { Component } from 'react';
import { translate } from 'react-polyglot';

import Modal from '../Modal';
import Rating from '../Rating';
import Button from '../Button';
import List from '../List';
import Pill from '../Pill';

import './OfflineTranslateSurveyForm.scss';

class OfflineTranslateSurveyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRating: -1,
      selectedReasons: []
    };
  }

  onSelectRating = (rating) => {
    this.setState({ selectedRating: rating, selectedReasons: [] });
  }

  onSelectReason = (reason) => {
    if (this.state.selectedReasons.includes(reason)) {
      this.setState({ selectedReasons: this.state.selectedReasons.filter(item => item !== reason) })
    }
    else {
      this.setState({ selectedReasons: [...this.state.selectedReasons, reason] })
    }
  }

  onSubmitOfflineTranslateForm = () => {
    const {
      t,
      onClose,
      postOfflineTranslationFeedbackWorkflow,
      addSlimNotification
    } = this.props;

    let reasonTitle = t('global.what-were-the-issues-faced');
    if (this.state.selectedRating >= 2) {
      reasonTitle = t('global.what-did-you-like');
    }

    const reasons = this.state.selectedReasons.map(reason => {
      return { reason, query_reason: reasonTitle }
    })

    const offlineTranslationFeedback = {
      // convert to 1-indexed rating
      rating: this.state.selectedRating + 1,
      editor_type: "OFFLINE",
      reasons
    }

    postOfflineTranslationFeedbackWorkflow(offlineTranslationFeedback)
      .then(response => {
        onClose();

        if (response.status === 'ok') {
          addSlimNotification({
            type: 'success',
            content: t('OfflineTranslateSurveyForm.form-submit-success')
          })
        }
        else {
          addSlimNotification({
            type: 'danger',
            content: response && response.error
          })
        }
      })
  }

  render() {
    const baseClassName = 'pb-offline-translate-survey-form';

    const {
      t,
      isSubmittingOfflineTranslationFeedback
    } = this.props;

    const status = [
      t('StarRatingModal.rating-not-great'),
      t('StarRatingModal.rating-okay'),
      t('StarRatingModal.rating-satisfied'),
      t('StarRatingModal.rating-good'),
      t('StarRatingModal.rating-excellent'),
    ]

    let reasons = [];
    let reasonTitle = '';

    if (this.state.selectedRating >= 2) {
      reasonTitle = t('global.what-did-you-like');
      reasons = [
        t('OfflineTranslateSurveyForm.works-without-internet'),
        t('OfflineTranslateSurveyForm.easy-to-use')
      ]
    }
    else if (this.state.selectedRating >= 0) {
      reasonTitle = t('global.what-were-the-issues-faced');
      reasons = [
        t('OfflineTranslateSurveyForm.difficult-to-use'),
        t('OfflineTranslateSurveyForm.difficult-to-publish')
      ]
    }

    return (
      <Modal parentClassName={`${baseClassName}__modal-wrapper`} starRating noContentScroll isRtl={this.props.isRtl}>
        <h2 className={`${baseClassName}__title`}>{t('OfflineTranslateSurveyForm.title')}</h2>
        <Rating parentClassName={`${baseClassName}__rating`} onSelect={this.onSelectRating} type="normal" surveyForm={true} />
        <div className={`${baseClassName}__reasons-wrapper`}>
          <p className={`${baseClassName}__status`}>{status[this.state.selectedRating]}</p>
          <p className={`${baseClassName}__reasons-title`}>{reasonTitle}</p>
          <List parentClassName={`${baseClassName}__reasons`} alignLeft>
            {
              reasons.map(reason => {
                return <Pill
                  key={reason}
                  label={reason}
                  onClick={this.onSelectReason.bind(this, reason)}
                  isSelected={this.state.selectedReasons.includes(reason)}
                  surveyForm={true}
                />
              })
            }
          </List>
        </div>
        <div className={`${baseClassName}__submit-btn-wrapper`}>
          <Button
            variant="primary"
            fullWidth
            label={t('global.submit')}
            isRtl={this.props.isRtl}
            onClick={this.onSubmitOfflineTranslateForm}
            loading={isSubmittingOfflineTranslationFeedback}
            parentClassName={`${baseClassName}__submit-btn`}
            long
            disabled={this.state.selectedRating === -1}
          />
        </div>
      </Modal>
    )
  }
}

OfflineTranslateSurveyForm.propTypes = {};

export default translate()(OfflineTranslateSurveyForm);



// WEBPACK FOOTER //
// ./src/components/OfflineTranslateSurveyForm/OfflineTranslateSurveyForm.jsx